<div class="ts-card">
    <div class="page-header">
        <h2 class="ts-card-title page-title">Allocate Trades</h2>
        <button class="btn-primary" type="button" (click)="loadData()">
            <fa-icon [icon]="faRotate"></fa-icon>
            Refresh
        </button>
    </div>
    <app-loading *ngIf="loading"></app-loading>

    <ng-container *ngIf="!loading">
        <app-allocations-table 
        [columns]="allocationColumns"
        [data]="allElements"
        [showTradeOrders]="true"
        (onAllocateNextClick)="allocateSelected($event)"
        (onRefresh)="loadData()">
        </app-allocations-table>
    </ng-container>
</div>